<div class="news-ticker-container">
  <ul class="news-ticker-list">
    <li *ngIf="isLoading" class="news-ticker-item">Loading news...</li>
    <li *ngIf="error && newsItems.length === 0" class="news-ticker-item">No news available.</li>
    <li *ngIf="!isLoading && !error && newsItems.length === 0" class="news-ticker-item">No news available.</li>
    <li *ngFor="let item of newsItems" class="news-ticker-item">
      <a 
        [href]="item.link" 
        target="_blank" 
        rel="noopener noreferrer"
        class="news-link">
        {{ item.title }}
      </a>
      <div class="news-time">
        {{ convertToNewYorkTimeOnly(item.pubDate) }}
      </div>
    </li>
  </ul>
</div>

